import { createContext, useContext, useState, useEffect } from "react";

/**
 * Context that stores if a Repository was selected 
 * so that the New snapshot button is enabled 
 */

const RepoContext = createContext({
  repoSelected: false,
  setRepoSelected: () => {},
});

//If the Repository is selected in the Dropbox the New Snapshot button is enabled
export const RepoProvider = ({ children }) => {
  const [repoSelected, setRepoSelected] = useState(
    localStorage.getItem("repoName") ? true : false
  );

  useEffect(() => {
    const repoName = localStorage.getItem("repoName");
    if (repoName) {
        // console.log("repoName",repoName)
      setRepoSelected(true);
    } else {
        // console.log("repoSelected",repoSelected)
      setRepoSelected(false);
    }
  }, []);

  return (
    <RepoContext.Provider value={{ repoSelected, setRepoSelected }}>
      {children}
    </RepoContext.Provider>
  );
};

export const useRepoSelected = () => useContext(RepoContext);
